import { motion, AnimatePresence } from 'framer-motion';

const FEATURES = [
  'Unlimited VIVI conversations in 14+ languages',
  'Voice-mode VIVI (talk + listen)',
  'All 16 personal assessments (8 women + 8 men)',
  '456 expert articles — full Education Library',
  '6 Intimacy Journeys + 15 Couple Exercises',
  '36 daily Affirmations — curated by Dr. Vikram',
  'Priority Dr. Vikram booking via WhatsApp',
  'Personalised intimate care routines',
];

export default function Paywall({ onClose, trigger = '' }) {
  return (
    <AnimatePresence>
      <motion.div
        className="paywall-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
        data-testid="paywall-overlay"
      >
        <motion.div
          className="paywall-sheet immersive-card"
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 60, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        >
          {trigger && (
            <div style={{ marginBottom: 16, padding: '10px 14px', background: 'var(--gold-dim)', border: '1px solid var(--border)', fontSize: '0.87rem', color: 'var(--text-muted)' }}>
              <i className="fa-solid fa-sparkles" style={{ color: 'var(--gold)', marginRight: 8 }} />
              {trigger}
            </div>
          )}

          <div className="flex-between mb-20">
            <div>
              <div className="eyebrow">INTIVIV™ · Free Early Access</div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap', marginTop: 4 }}>
                <span style={{
                  fontFamily: "'Inter', system-ui, sans-serif",
                  fontSize: '2.05rem', lineHeight: 1.1,
                  color: '#FFE9A6',
                  fontWeight: 700,
                  letterSpacing: '-0.005em',
                  textShadow: '0 2px 12px rgba(212,175,55,0.45)',
                }}>
                  Welcome to INTIVIV
                </span>
              </div>
              <div style={{ fontSize: '0.94rem', color: 'var(--text-muted)', fontWeight: 500, marginTop: 4 }}>
                Full access · No payment · Pre-Launch
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
                <span style={{
                  display: 'inline-block', padding: '3px 9px',
                  background: 'rgba(232,180,184,0.18)',
                  color: '#E8B4B8',
                  fontSize: '0.69rem', letterSpacing: '0.16em', fontWeight: 700,
                  border: '1px solid rgba(232,180,184,0.38)',
                }}>
                  INVITE-ONLY · PRE-LAUNCH
                </span>
              </div>
            </div>
            <button className="btn-ghost" onClick={onClose} style={{ fontSize: '1.2rem' }} data-testid="paywall-close">
              <i className="fa-solid fa-xmark" />
            </button>
          </div>

          <div className="immersive-card-inner" style={{ padding: 22, position: 'relative' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 6,
              fontSize: '0.71rem', fontWeight: 700, letterSpacing: '0.18em',
              padding: '4px 10px', background: 'rgba(34,197,94,0.12)',
              color: '#22c55e', marginBottom: 16, border: '1px solid rgba(34,197,94,0.3)',
            }}>
              <i className="fa-solid fa-circle-check" /> FULL ACCESS — PRE-LAUNCH
            </div>

            <p style={{ fontSize: '1.01rem', color: 'var(--text)', lineHeight: 1.72, marginBottom: 14 }}>
              You're in. As an early access member, every feature is fully unlocked — <strong style={{ color: 'var(--gold)' }}>VIVI Coach, Education Library, all 16 Assessments, Couple Exercises, Affirmations and direct WhatsApp consult</strong>.
            </p>
            <p style={{ fontSize: '0.92rem', color: 'var(--text-muted)', lineHeight: 1.7, marginBottom: 18 }}>
              You are among the first to experience the world's only gynaecologist-led AI intimate wellness ecosystem. We'd love your honest feedback.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 18 }}>
              {FEATURES.map(f => (
                <div key={f} style={{ display: 'flex', gap: 10, fontSize: '0.9rem', color: 'var(--text-muted)', alignItems: 'flex-start' }}>
                  <i className="fa-solid fa-check" style={{ color: 'var(--gold)', fontSize: '0.79rem', flexShrink: 0, marginTop: 4 }} />
                  <span>{f}</span>
                </div>
              ))}
            </div>

            <button
              onClick={() => { onClose?.(); }}
              className="btn-gold w-full"
              style={{ fontSize: '0.87rem' }}
              data-testid="continue-free-btn"
            >
              CONTINUE EXPLORING INTIVIV
            </button>
          </div>

          <div style={{ fontSize: '0.77rem', color: 'var(--text-dim)', textAlign: 'center', marginTop: 14, lineHeight: 1.6 }}>
            <i className="fa-solid fa-shield-halved" style={{ color: 'var(--gold)', marginRight: 4 }} />
            Free Early Access · Pre-Launch · End-to-end encrypted · 100% confidential
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
